import { Check, Clock, History } from 'lucide-react';
import { KATEGORIE_TEXT, VORLAGEN, type Vorlage } from '../../lib/mailBuilder/vorlagen';

type Props = {
  gewaehlt: string | null;
  onWahl: (v: Vorlage) => void;
};

export function SchrittVorlage({ gewaehlt, onWahl }: Props) {
  const v = VORLAGEN.find((x) => x.id === gewaehlt) ?? null;
  return (
    <>
      <div className="kachel-gitter as-vorlagen" role="radiogroup" aria-label="Vorlage">
        {VORLAGEN.map((x) => {
          const aktiv = x.id === gewaehlt;
          return (
            <button
              key={x.id}
              type="button"
              role="radio"
              aria-checked={aktiv}
              className={`auswahl-kachel art-kachel${aktiv ? ' aktiv' : ''}`}
              onClick={() => onWahl(x)}
            >
              <span className="as-emoji" aria-hidden="true">{x.emoji}</span>
              <span className="art-text">
                <strong>{x.name}</strong>
                <span>{x.kurz}</span>
                <span className="as-kategorie">{KATEGORIE_TEXT[x.kategorie]}</span>
              </span>
              {aktiv && <Check size={16} className="kachel-haken" aria-hidden="true" />}
            </button>
          );
        })}
      </div>

      {v && (
        <div className="as-vorlage-info">
          <p><strong>Wann Du sie nimmst:</strong> {v.wann}</p>
          <p><Clock size={14} aria-hidden="true" /> <strong>Vorlauf:</strong> {v.vorlauf}</p>
          <p><History size={14} aria-hidden="true" /> <strong>Gebaut nach:</strong> {v.vorbild.join(' · ')}</p>
        </div>
      )}
    </>
  );
}
